import { observable, freeze }  from 'rewire-core';
import { RouteManagerBase }    from './RouteManager';

export interface IBreadcrumbsModelState {
  search?: string;
  areaId?: string;
  groupId?: string;
  viewId?: string;
}

export class BreadcrumbsModel {
  state: IBreadcrumbsModelState;

  constructor() {
    this.state = observable({
      search: undefined,
      areaId: undefined,
      groupId: undefined,
      viewId: undefined,
    });
  }

  update() {
    freeze(() => {
      this.state.search  = RouteManagerBase.current.allFilters?.search;
      this.state.areaId  = RouteManagerBase.current.areaId;
      this.state.groupId = RouteManagerBase.current.groupId;
      this.state.viewId  = RouteManagerBase.current.viewId;
    });
  }

  get areaId(): string | undefined {
    return this.state.areaId;
  }

  get search(): string | undefined {
    return this.state.search;
  }

  get groupId(): string | undefined {
    return this.state.groupId;
  }

  get viewId(): string | undefined {
    return this.state.viewId;
  }
}

const breadcrumbsModel = new BreadcrumbsModel();
export default breadcrumbsModel;
